import { render } from "./replyStatusHistoryModal.vue?vue&type=template&id=05b61cdc&ts=true"
import script from "./replyStatusHistoryModal.vue?vue&type=script&lang=ts"
export * from "./replyStatusHistoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__